// extracted by mini-css-extract-plugin
export default {"container":"TraitList_container__8v1OQ","loading":"TraitList_loading__Q+Wwf"};